import React from "react";
import DashBoard from "./Components/index";
import { fromHourly, toHourly } from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const auth = useAuth();
  const activeGroup = auth.state.activeGroup;
  const fromDate = fromHourly(queryString.parse(props.location.search).date);
  const toDate = toHourly(queryString.parse(props.location.search).date);

  const onClickLineChart = (date) => {
    props.history.push(`/dashboard/details?activeGroup=${activeGroup}&date=${date}&interval=minutes`);
  };
  const onClickListButton = (date) => {
    props.history.push(`/dashboard/details?activeGroup=${activeGroup}&date=${date}&interval=hourly`);
  };
  const onClickReTweet = (id, dateTime) => {
    props.history.push(
      `/retweets/details?activeGroup=${activeGroup}&id=${id}&date=${dateTime}`
    );
  };
  const onClickUser = (screen_name) => {
    props.history.push(`/users/details?activeGroup=${activeGroup}&user=${screen_name}&dateTo=${toDate}&dateFrom=${fromDate}`);
  };
  const onClickKeyword = (word, dateTime) => {
    props.history.push(`/keywords/details?activeGroup=${activeGroup}&word=${word}&date=${dateTime}&interval=hourly`);
  };
  const handleDateChange = (date) => {
    props.history.push(`/dashboard/hourly?activeGroup=${activeGroup}&date=${date}`);
  };

  return (
    <DashBoard
      fromDate={fromDate}
      toDate={toDate}
      unit="min5"
      target="hourly"
      onClickLineChart={onClickLineChart}
      onClickListButton={onClickListButton}
      onClickReTweet={onClickReTweet}
      onClickUser={onClickUser}
      onClickKeyword={onClickKeyword}
      handleDateChange={handleDateChange}
    />
  );
}

export default withRouter(Page);
